import {RequiredRule, Validator} from 'devextreme-react/validator';
import {useContext} from 'react';
import DateWithTimeBox from '../../../../components/date-with-time/DateWithTimeBox';
import {Field, Panel} from '../../../../layouts';
import {AR, QuoteStatus} from '../../../../types/enums';
import {EstimateContext} from '../context/EstimateContext';

export default function ScheduleDatePanel() {

	const { order, modifyOrder } = useContext(EstimateContext);

	const isOrderReadonly =
		order.details.statusID === QuoteStatus.Closed ||
		order.details.statusID === QuoteStatus.Cancelled ||
		order.details.statusID === QuoteStatus.Expired ||
		order.details.statusID === QuoteStatus.Pending;

	const dateReadOnly = !(order.details.activeARs.includes(AR.LeadScheduleAppointment) ||
		(order.details.resolvedARs.includes(AR.LeadScheduleAppointment) &&
			!order.details.resolvedARs.includes(AR.LeadSubmitEstimate))) || isOrderReadonly;

	let dateRequired = !dateReadOnly;

	return (
		<Panel header={'Dates'} >

			<Field label="Scheduled Appointment Date">
				<DateWithTimeBox value={order.details.scheduledAppointmentDate}
					startHour={8}
					endHour={17}
					stepInMinutes={30}
					timeRequired={dateRequired}
					onValueChanged={(e) => modifyOrder({ ...order.details, scheduledAppointmentDate: e.value })}
					readOnly={dateReadOnly}
					className={dateRequired ? 'required' : ''}
					min={!dateReadOnly ? new Date() : undefined}>
					<Validator>
						{dateRequired && order.modified &&
							<RequiredRule message={'Scheduled Appointment Date is required'} />}
					</Validator>
				</DateWithTimeBox>
			</Field>
		</Panel>
	);
}
